<div class="footer-content">
  <div class="box">
    <h2>LAGERADRÄSSE</h2>
    <p>Gruppenunterkunft Haus der Jugend</p>
    <p>Hürleni 59</p>
    <p>1716 Schwarzsee</p>
  </div>
  <div class="box">
    <h2>NÜÜS VO ÜÜS</h2>
    <p>Danke vill</p>
    <p>mal für das</p>
    <p>coole Lager :)</p>
  </div>
</div>
